import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MatDialog } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-actividad-notas',
  templateUrl: './actividad-notas.component.html',
  styleUrls: ['./actividad-notas.component.scss']
})
export class ActividadNotasComponent implements OnInit {

  public notas: string;
  public disabled: boolean;

  /**
   * Constructor
   * 
   * @param data 
   * @param {MatSnackBar} _snackBar 
   * @param {MatDialogRef<ActividadNotasComponent>} matDialogRef 
   */
  constructor 
  (
    @Inject(MAT_DIALOG_DATA) public data, 
    private _snackBar: MatSnackBar, 
    private matDialogRef: MatDialogRef<ActividadNotasComponent>
  ) { }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Init
   */
  ngOnInit() {
    this.notas = this.data['modal'];
    this.disabled = this.data['disabled'];
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Cierra el Modal devolviendo la variable notas al componente que lo llamo
   */
  public guardarNotas(){
    this.matDialogRef.close(this.notas);
    if(this.data['modal']){
      this._snackBar.open('Notas Actualizadas', 'Aceptar', {
        duration: 2000
      });
    }else{
      this._snackBar.open('Notas agregadas', 'Aceptar', {
        duration: 2000
      });
    }
  }
}